var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}],class:_vm.color,attrs:{"id":"svg-polygons-bg"}},[_c('div',{ref:"bg",attrs:{"id":"svg-polygons"}})])}
var staticRenderFns = []

export { render, staticRenderFns }